export interface IGetSumExpenses {
  plantId?: string;
  routeId?: string;
  expensesType?: string | null;
  userId?: string;
  fromDate?: string;
  toDate?: string;
  fromPrice: number;
  toPrice: number;
}

export interface IGetAllExpenses extends IGetSumExpenses {
  skip: number;
  take: number;
  type?: string;
  headerRow?: any;
}

export interface IGetAllEmployees {
  search?: string;
}

export interface ICreateExpense {
  startDate: string;
  customerId: string;
  routeId: string;
  teamSalesId: string;
  userId: string;
  expensesType: string;
  policyExpenses: number;
  actualExpenses: number;
  numberPerson: number;
  finalExpenses: number;
  note: string;
  plantId: string;
}

export interface IGetRoutes {
  skip: number;
  take: number;
  teamId: string;
  plantId: string;
  implementationDateFrom: string;
}

export interface IUpdateExpense extends ICreateExpense {
  id: string;
}

export const EXPENSES_VARIABLES = {
  getAllExpenses: ({
    skip,
    take,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    headerRow,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    type,
    ...input
  }: IGetAllExpenses) => {
    return {
      skip,
      take,
      input,
    };
  },
  getSumExpenses: (input: IGetSumExpenses) => {
    return {
      input,
    };
  },
  getAllEmployees: ({ search }: IGetAllEmployees) => {
    return {
      skip: 0,
      take: 100,
      input: {
        OR: [
          {
            ...(search && {
              employeeId: {
                equals: search,
              },
            }),
          },
          {
            ...(search && {
              fullName: {
                contains: search,
              },
            }),
          },
        ],
      },
    };
  },
  getAllExpensesType: () => {
    return {
      skip: 0,
      take: 100,
      input: {},
    };
  },
  createExpenses: (input: ICreateExpense) => {
    return {
      input,
    };
  },
  updateExpenses: (input: IUpdateExpense) => {
    return {
      input,
    };
  },
  getRoutes: ({ skip, take, ...input }: IGetRoutes) => {
    return {
      skip,
      take,
      input,
    };
  },
};
